import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { _AuthenticationService } from "../../services/auth.service";
import { _UserService } from "../../services/user.service";

@Component({
  selector: "forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.css"],
  providers: [_AuthenticationService],
})
export class ForgotPasswordPage implements OnInit {
  model: any = {};
  loading = false;
  error = "";
  result: any;

  constructor(
    private router: Router,
    private titleService: Title,
    private authenticationService: _AuthenticationService
  ) {}

  ngOnInit() {
    //Set the page title
    this.titleService.setTitle("WiseRisk | Forgot password");
  }

  forgotPassword() {
    this.loading = true;

    this.result = this.authenticationService
      .resetPassword(this.model.username)
      .subscribe(
        (res) => {
          this.navigateAfterSuccess();
          this.error = null;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.error = "Try to later";
        }
      );
  }

  private navigateAfterSuccess() {
    this.router.navigate(["/login"]);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/forgot-password/forgot-password.component.ts